import { useMutation } from '@tanstack/react-query';
import type {
  CreateCryptoAddressRequestDto,
  CreateCryptoAddressResponseDto,
} from '../../model';
import { createCryptoAddress } from '../requests';

interface Options {
  onSuccess?: (data: CreateCryptoAddressResponseDto) => void;
  onError?: (error: Error) => void;
}

type CreateCryptoAddressVariables = {
  networkName: string;
  data: CreateCryptoAddressRequestDto;
};

export function useCreateCryptoAddress({ onSuccess, onError }: Options = {}) {
  const mutation = useMutation<
    CreateCryptoAddressResponseDto,
    Error,
    CreateCryptoAddressVariables
  >({
    mutationFn: ({ networkName, data }) =>
      createCryptoAddress(networkName, data),
    onSuccess,
    onError,
  });

  return {
    mutate: mutation.mutate,
    mutateAsync: mutation.mutateAsync,
    data: mutation.data,
    isPending: mutation.isPending,
    error: mutation.error,
  };
}
